import { createStore } from 'vuex'

// 创建一个新的 store 实例
const store = createStore({
  state() {
    const user = localStorage.getItem('user');
    let userInfo = null;
    let isLogin = false;

    if (user) {
      try {
        userInfo = JSON.parse(user);
        isLogin = true;
      } catch (e) {
        console.error('解析 localStorage 中的用户信息失败:', e);
        localStorage.removeItem('user'); // 清除损坏的数据
      }
    }

    return {
      isLogin: isLogin,
      userInfo: userInfo
    }
  },
  mutations: {
    setLoginState(state, isLogin) {
      state.isLogin = isLogin;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    clearUserState(state) {
      state.isLogin = false;
      state.userInfo = null;
    }
  },
  actions: {
    // 登录
    login({ commit }, userInfo) {
      commit('setLoginState', true);
      commit('setUserInfo', userInfo);
    },
    // 登出
    logout({ commit }) {
      commit('clearUserState');
    }
  },
  getters: {
    isLogin: state => state.isLogin,
    userInfo: state => state.userInfo
  }
})

export default store 